import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const Tip = ({ active, payload }) => {
  const p = payload?.[0]?.payload;
  if (!active || !p) return null;
  return (
    <div className="bg-zinc-900 text-white px-3 py-2 text-xs font-mono">
      <div className="text-zinc-400">Week {p.weeknr}</div>
      <div><span className="text-red-400">●</span> {p.gestresst} gestresst</div>
      <div><span className="text-zinc-400">●</span> {p.neutraal} neutraal</div>
      <div><span className="text-emerald-400">●</span> {p.ontspannen} ontspannen</div>
      {p.score !== null && <div className="mt-1">Gem. score {p.score > 0 ? "+" : ""}{p.score}</div>}
    </div>
  );
};

export const UnitMoodCard = ({ unit }) => {
  const last = [...unit.series].reverse().find((s) => s.score !== null);
  const data = unit.series.map((s) => ({ ...s, line: s.score === null ? null : s.score }));
  return (
    <div className="border border-zinc-900" data-testid={`mood-unit-${unit.key}`}>
      <div className="flex items-stretch border-b border-zinc-900">
        <div className="w-14 bg-zinc-900 text-white flex items-center justify-center font-grotesk font-bold">{unit.system}</div>
        <div className="px-4 py-2 flex-1 min-w-0">
          <div className="font-grotesk font-semibold truncate">{unit.name}</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{unit.members} {unit.members === 1 ? "medewerker" : "medewerkers"}</div>
        </div>
        <div className="px-4 py-2 text-right">
          <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Nu</div>
          <div className="font-grotesk font-bold text-lg" data-testid={`mood-unit-score-${unit.key}`}>{last ? `${last.score > 0 ? "+" : ""}${last.score}` : "–"}</div>
        </div>
      </div>
      <div className="h-48 p-2">
        <ResponsiveContainer>
          <ComposedChart data={data} margin={{ top: 8, right: 0, bottom: 0, left: -20 }}>
            <CartesianGrid stroke="#f4f4f5" vertical={false} />
            <XAxis dataKey="weeknr" tickFormatter={(w) => `wk ${w}`} tick={{ fontSize: 10, fill: "#71717a" }} stroke="#d4d4d8" interval="preserveStartEnd" />
            <YAxis yAxisId="n" allowDecimals={false} tick={{ fontSize: 10, fill: "#71717a" }} stroke="#d4d4d8" />
            <YAxis yAxisId="s" orientation="right" domain={[-1, 1]} ticks={[-1, 0, 1]} tickFormatter={(v) => (v > 0 ? "+1" : v < 0 ? "−1" : "0")} tick={{ fontSize: 10, fill: "#18181b" }} stroke="#d4d4d8" width={28} />
            <Tooltip content={<Tip />} cursor={{ fill: "#f4f4f5" }} />
            <Bar yAxisId="n" dataKey="gestresst" stackId="a" fill="#dc2626" />
            <Bar yAxisId="n" dataKey="neutraal" stackId="a" fill="#a1a1aa" />
            <Bar yAxisId="n" dataKey="ontspannen" stackId="a" fill="#059669" />
            <Line yAxisId="s" dataKey="line" stroke="#18181b" strokeWidth={2} dot={{ r: 2.5, fill: "#18181b" }} connectNulls isAnimationActive={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
